import DownloadIcon from "@mui/icons-material/Download";
import { Autocomplete, TextField } from "@mui/material";
import { useState } from "react";
import AutoCompleteUIDTO from "../../dto/AutoCompleteUIDTO";
import { generateReportAndDownload } from "../../utils/FileUtils";
import { ButtonComponent } from "../ButtonComponent";

interface Props {
  date: Date;
  search: AutoCompleteUIDTO;
  focusProjectNameInput?: any;
  className: string;
}

type Report = { label: string; reportPDFName: string; reportXLSXName: string };

const reportsNames: Report[] = [
  {
    label: "Weekly Dedication Report",
    reportPDFName: "PDF_WEEKLY_HOURS",
    reportXLSXName: "XLSX_WEEKLY_HOURS",
  },
  {
    label: "Daily-Detailed Team Report",
    reportPDFName: "PDF_DAILY_REPORT",
    reportXLSXName: "XLSX_DAILY_REPORT",
  },
  {
    label: "Vacation Report",
    reportPDFName: "PDF_VACATION_REPORT",
    reportXLSXName: "XLSX_VACATION_REPORT",
  },
  {
    label: "Multimonth Worklog Report",
    reportPDFName: "",
    reportXLSXName: "XLSX_MULTIMONTH_REPORT",
  },
];

const WorklogReportDownload = (props: Props) => {
  const { date, search, focusProjectNameInput, className } = props;
  const [selectedReport, setSelectedReport] = useState<Report>(reportsNames[0]);

  return (
    <div className={className}>
      <Autocomplete
        fullWidth
        getOptionLabel={(option) => option.label}
        options={reportsNames}
        value={selectedReport}
        onChange={(event, newValue) => {
          setSelectedReport(newValue);
        }}
        renderInput={(params) => <TextField {...params} label="Download Reports" variant="outlined" />}
        size="small"
        disableClearable
      />

      <ButtonComponent
        debounce
        icon={<DownloadIcon />}
        text="PDF"
        onClick={() => generateReportAndDownload(selectedReport?.reportPDFName, date, search)}
        disabled={selectedReport === reportsNames.find((r) => r.label === "Multimonth Worklog Report")}
      />
      <ButtonComponent
        debounce
        icon={<DownloadIcon />}
        text="XLSX"
        onClick={() => generateReportAndDownload(selectedReport?.reportXLSXName, date, search)}
      />
    </div>
  );
};

export default WorklogReportDownload;
